import React from "react"

export function TestimonialSlider({ header = '', slides = [] }) {
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const handleSlideChange = (direction) => {
    setCurrentSlide(current => {
      if (direction === 'next') {
        return current >= slides?.length - 1 ? 0 : current + 1;
      }
      return current <= 0 ? slides.length - 1 : current - 1;
    });
  };

  React.useEffect(() => {
    const interval = setInterval(() => handleSlideChange('next'), 8000);

    return () => clearInterval(interval);
  }, [handleSlideChange]);

  const SliderContent = ({
    image,
    name = '',
    position,
    content = '',
    index
  }) => {
    return (
      <div
        className={`tw-border-primary tw-rounded-lg tw-p-4 md:tw-p-8 tw-gap-4 md:tw-gap-8 tw-flex ${currentSlide === index ? 'tw-flex-col md:tw-flex-row tw-bg-opacity-100' : 'tw-opacity-0 tw-hidden'}`}
        style={{
          border: '1px solid #E6E6E6',
          transition: 'opacity 2s ease-in-out',
        }}>
        <img src={image ?? '/assets/images/shops/apos002s.jpeg'} alt={name} width={220} height={220} loading="lazy" className="tw-w-[220px] tw-h-[220px] tw-rounded-2xl tw-bg-primary" />

        <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-4 md:tw-gap-8 tw-mt-4 md:tw-mt-8">
          <p className="tw-text-black">{content}</p>

          <div>
            <h6 className="tw-text-black">- {name}</h6>
            {position && <p className="small">{position}</p>}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="tw-max-w-full tw-space-y-4 md:tw-space-y-8">
      <h2 className="tw-text-black">{header}</h2>

      <div className="tw-max-w-full tw-relative tw-m-auto">
        {slides.map((_, i) => <SliderContent key={i} index={i} {..._} />)}
      </div>

      <div className="tw-flex tw-gap-4 md:tw-gap-8 lg:tw-gap-16 tw-items-center">
        <div className="tw-flex tw-gap-4 md:tw-gap-8">
          <button
            onClick={() => handleSlideChange('prev')}
            style={{
              all: 'unset',
              cursor: 'pointer'
            }}>
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M21.3125 16.5H13.0625" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.8125 12.375L11.6875 16.5L15.8125 20.625" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <button onClick={() => handleSlideChange('next')}
            style={{
              all: 'unset',
              cursor: 'pointer'
            }}>
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M11.6875 16.5H19.9375" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M17.1875 20.625L21.3125 16.5L17.1875 12.375" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="tw-flex-1 tw-bg-gray-300 tw-h-2">
          <div className={`tw-h-2 tw-bg-primary`} style={{
            width: `${(currentSlide + 1) * 100 / slides.length + 1}%`,
            transition: 'width 2s ease-in-out',
          }}></div>
        </div>
      </div>
    </div>
  )
};
